/*
 * LynqOne reactive cart layer (Alpine).
 * A single global $store.cart is the source of truth for the cart count.
 * Any element that binds to it (the header badge, etc.) updates on its own.
 */
(function () {
  var ROOT =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    '/';

  document.addEventListener('alpine:init', function () {
    Alpine.store('cart', {
      // Seeded from the server so there is no flash before hydration.
      count:
        typeof window.lqInitialCartCount === 'number'
          ? window.lqInitialCartCount
          : 0,
      loading: false,

      // Pull the real cart state from Shopify.
      refresh: function () {
        var self = this;
        return fetch(ROOT + 'cart.js', {
          headers: { Accept: 'application/json' },
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            self.count = cart.item_count;
            return cart;
          });
      },

      // Add a product form's contents to the cart. Returns { ok, message }.
      add: function (formEl) {
        var self = this;
        self.loading = true;
        var data = new FormData(formEl);
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data,
        })
          .then(function (r) {
            return r.json().then(function (j) {
              return { ok: r.ok, body: j };
            });
          })
          .then(function (res) {
            if (!res.ok) {
              self.loading = false;
              return {
                ok: false,
                message:
                  (res.body && res.body.description) ||
                  'Could not add to cart. Please try again.',
              };
            }
            return self.refresh().then(function () {
              self.loading = false;
              return { ok: true, message: 'Added to your cart.' };
            });
          })
          .catch(function () {
            self.loading = false;
            return {
              ok: false,
              message: 'Could not add to cart. Please try again.',
            };
          });
      },
    });

    // Component for the buy box: adds to cart, then sends the user to the cart
    // page to review and check out. Only surfaces inline text on failure.
    Alpine.data('lqBuy', function () {
      return {
        adding: false,
        status: '',
        error: false,
        cartUrl: ROOT + 'cart',
        submit: function (e) {
          var self = this;
          self.adding = true;
          self.error = false;
          self.status = '';
          Alpine.store('cart')
            .add(e.target)
            .then(function (res) {
              if (res.ok) {
                // Go straight to the styled cart/checkout page.
                window.location.href = self.cartUrl;
                return;
              }
              self.adding = false;
              self.error = true;
              self.status = res.message;
            });
        },
      };
    });
  });
})();
